import {Component, OnInit, Inject} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ABWToastService } from 'src/app/shared/helpers/abw-toast.service';
import { TYPE_DATASOURCE, AbwDatasourceProviderItem, Model_Datasource, StartupInfos_Datasource, TYPE_DATASOURCE_FILTER_OPTIONS } from 'src/app/app.models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';

@Component({
    selector: 'app-datasource-form-modal',
    templateUrl: './datasource-form-modal.page.html',
    styleUrls: ['./datasource-form-modal.page.scss']
})
export class DatasourceFormModalPage implements OnInit {
    datasource?: Model_Datasource;
    startupInfos?: StartupInfos_Datasource;
    loading = false;
    formGroup = this._formBuilder.group({
        ID: [null],
        TITRE: [null, Validators.required],
        TYPE_DATASOURCE: [TYPE_DATASOURCE.STATIC, Validators.required],
        DS_PROVIDER_NAME: [null]
    });
    TYPE_DATASOURCE_FILTER_OPTIONS = TYPE_DATASOURCE_FILTER_OPTIONS.filter(o => o.mVALUE_MEMBER !== TYPE_DATASOURCE.ALL);
    TYPE_DATASOURCE = TYPE_DATASOURCE;
    selectedDsProvider: AbwDatasourceProviderItem[] = [];

    constructor(
        private _formBuilder: FormBuilder,
        private _toastrService: ABWToastService,
        public _datasourceService: DatasourceService,
        public dialogRef: MatDialogRef<DatasourceFormModalPage>,
        @Inject(MAT_DIALOG_DATA) public data: { datasource?: Model_Datasource, startupInfos?: StartupInfos_Datasource },
    ) {
        let promise = Promise.resolve();
        if (!!data.startupInfos) {
            this.startupInfos = data.startupInfos;
        } else {
            promise = this._doGetStartupInfos();
        }
        if (!!data.datasource) {
            this.datasource = data.datasource;
            this.formGroup.patchValue({
                ID: this.datasource.ID,
                TITRE: this.datasource.TITRE,
                TYPE_DATASOURCE: this.datasource.TYPE_DATASOURCE,
                DS_PROVIDER_NAME: this.datasource.DS_PARAMS?.name,
            });
            promise.then(() => {
                this.onTypeDatasourceChanged({ value: this.datasource.TYPE_DATASOURCE });
            });
        }
    }

    ngOnInit() {
    }

    dismiss() {
        return this.dialogRef.close();
    }

    get fields() {
        return this.formGroup.controls;
    }

    onSubmit() {
        if (this.formGroup.invalid)
            return;

        const DS_PARAMS: any = this.datasource !== undefined ? this.datasource.DS_PARAMS : { name: null };
        DS_PARAMS.name = this.formGroup.controls.DS_PROVIDER_NAME.value;
        if (this.formGroup.controls.TYPE_DATASOURCE.value == TYPE_DATASOURCE.WORKFLOWS) {
            DS_PARAMS.WS_PARAMS = { NUM_WORKFLOW: this.formGroup.controls.DS_PROVIDER_NAME.value };
        }
        const item: any = {
            ID: this.formGroup.controls.ID.value,
            TYPE_DATASOURCE: this.formGroup.controls.TYPE_DATASOURCE.value,
            TITRE: this.formGroup.controls.TITRE.value,
            DS_PARAMS: DS_PARAMS
        };
        this.loading = true;
        this._datasourceService.doSaveDatasourceAction(item).subscribe((_itemSaved) => {
            this.loading = false;
            return this.dialogRef.close(_itemSaved);
        }, (error: string) => {
            this._toastrService.showToast(error);
            this.loading = false;
        });
    }

    onTypeDatasourceChanged(_event: { value: any }) {
        const dsProvider = this.startupInfos.datasourceProviders[_event.value];
        if (dsProvider == undefined)
            return;

        this.selectedDsProvider = dsProvider;
    }

    private _doGetStartupInfos() {
        return new Promise<void>((resolve, reject) => {
            this.loading = true;
            this._datasourceService.doGetStartupInfosAction().subscribe(_startupInfos => {
                this.startupInfos = _startupInfos;
                this.loading = false;
                resolve();
            }, (error: string) => {
                this._toastrService.showToast(error);
                this.loading = false;
                reject();
            });
        });
    }
}